export class PersonalDetailModel {

  private pias_rep_code!: string;
  private fullNameNric!: string;
  private preferredName!: string;
  private nricNo!:number;
  private dateOfBirth!: string;
  private gender!: string;
  private nationality!: string;
  private placeOfBirth!: string;
  private finPassportNo!: number;
  private Race!: string;
  private maritalStatus!: string;
  

//  "pias_rep_code": "PS2023",
//     "fullNameNric": "John Doe Adam",
//     "preferredName": "John",
//     "nricNo": "S1234567A",
//     "dateOfBirth": "2026-06-03",
//     "gender": "Male",
//     "nationality": "Singaporean",
//     "placeOfBirth":"",
//     "finPassportNo":"",
//     "Race":"",
//     "maritalStatus":""

  constructor() { }

  // Getters & Setters
  getPiasrepCode(): string {
    return this.pias_rep_code;
  }
  setPiasrepCode(pias_rep_code: string) {
  this.pias_rep_code = pias_rep_code;
  }

  getFullNameNric(): string {
    return this.fullNameNric;
  }
  setFullNameNric(fullNameNric: string) {
  this.fullNameNric = fullNameNric;
  }
  getPreferredName(): string {
    return this.preferredName;
  }
  setPreferredName(preferredName: string) {
    this.preferredName = preferredName;
  }
  getNricNo(): number {
    return this.nricNo;
  }
  setNricNo(nricNo: number) {
    this.nricNo = nricNo;
  }
  getDateOfBirth(): string {
    return this.dateOfBirth;
  }
  setDateOfBirth(dateOfBirth: string) {
    this.dateOfBirth = dateOfBirth;
  }
  getGender(): string {
    return this.gender;
  }
  setGender(gender: string) {
    this.gender = gender;
  }
  getNationality(): string {
    return this.nationality;
  }
  setNationality(nationality: string) {
    this.nationality = nationality;
  }
  getPlaceOfBirth(): string {
    return this.placeOfBirth;
  } 
  setPlaceOfBirth(placeOfBirth: string) {
    this.placeOfBirth = placeOfBirth;
  }
  getFinPassportNo(): number {
    return this.finPassportNo;
  } 
  setFinPassportNo(finPassportNo: number) {
    this.finPassportNo = finPassportNo;
  }
  getRace(): string {
    return this.Race;
  } 
  setRace(Race: string) {
    this.Race = Race;
  }
  getMaritalStatus(): string {
    return this.maritalStatus;
  } 
  setMaritalStatus(maritalStatus: string) {
    this.maritalStatus = maritalStatus;
  } 

  toString() {
        return JSON.stringify({
            pias_rep_code:this.getPiasrepCode(),
            fullNameNric: this.getFullNameNric(),
            preferredName: this.getPreferredName(),
            nricNo: this.getNricNo(),
            dateOfBirth: this.getDateOfBirth(),
            gender: this.getGender(),
            nationality: this.getNationality(),
            placeOfBirth: this.getPlaceOfBirth(),
            finPassportNo: this.getFinPassportNo(),
            Race: this.getRace(),
            maritalStatus: this.getMaritalStatus()
        });
    }

  
}

      
